import React, { useState } from 'react';

import ModalComponent from '../../../../common-components/ModalComponent/ModalComponent';

import './_survey.scss';

import { TRIAL_USER_ONBOARDING_MODAL_DATA } from '@/utils/constants/onboarding';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import OnboardingModal from '@/components/common-components/OnboardingModal/OnboardingModal';

import { initializeOnboardingFormData } from '../../../../../utils/survey-utils';
import {
  surveyForm1V2Validation,
  surveyForm1Validation,
  surveyForm2V2Validation,
  surveyForm2Validation,
  surveyForm3Validation,
} from '../../../../../utils/validationSchema';
import { SurveyContext } from './surveyContext';
import SurveyFinalScreen from './SurveyFinalScreen';
import SurveyPage1 from './SurveyPage1';
import SurveyPage2 from './SurveyPage2';
import SurveyPage3 from './SurveyPage3';
import SurveyProgress from './SurveyProgress';
import NewOnboardingStepButtons from './v2Users/NewOnboardingStepButtons';
import SurveyPage1V2 from './v2Users/SurveyPage1';
import SurveyPage2V2 from './v2Users/SurveyPage2';
import SurveyFinalScreenV2 from './v2Users/SurveyPage3';

export default function SurveyForm({ show, onClose }) {
  const { userDetails } = useSelector((state) => state.user);
  const [surveyFormStep, setSurveyFormStep] = useState(userDetails?.accountVersion === 'v1' ? 1 : 5);
  const [isNextDisabled, setIsNextDisabled] = useState(true);

  const [form1Data, setForm1Data] = useState(() =>
    initializeOnboardingFormData('form1', surveyForm1Validation, { website: '', role: '' })
  );

  const [form2Data, setForm2Data] = useState(() =>
    initializeOnboardingFormData('form2', surveyForm2Validation, { whySaral: '', saralReferal: '' })
  );

  const [form3Data, setForm3Data] = useState(() =>
    initializeOnboardingFormData('form3', surveyForm3Validation, { revenue: '', objective: '', teamSize: '' })
  );

  const [form1V2Data, setForm1V2Data] = useState(() =>
    initializeOnboardingFormData('form1V2', surveyForm1V2Validation, { winForBrand: '', roadblocks: '' })
  );

  const [form2V2Data, setForm2V2Data] = useState(() =>
    initializeOnboardingFormData('form2V2', surveyForm2V2Validation, { objective: '' })
  );

  const [showNewOnboardingSteps, setShowNewOnboardingSteps] = useState(false);

  const [userType, setUserType] = useState(userDetails?.accountVersion);

  const finalScreenType =
    ['$3M - $10M', '$10M+'].includes(form3Data.revenue) || ['25-50', '50-100', '100+'].includes(form3Data.teamSize)
      ? 'personalized'
      : 'normal';

  const navigate = useNavigate();

  const handleVideoProgress = (progress) => {
    setIsNextDisabled(progress.played * 100 < 90);
  };

  const renderForm = () => {
    switch (surveyFormStep) {
      case 1:
        return <SurveyPage1 />;
      case 2:
        return <SurveyPage2 />;
      case 3:
        return <SurveyPage3 />;
      case 4:
        return <SurveyFinalScreen type={finalScreenType} onClose={onClose} />;
      case 5:
        return <SurveyPage1V2 />;
      case 6:
        return <SurveyPage2V2 />;
      case 7:
        return (
          <SurveyFinalScreenV2
            onClose={() => {
              setShowNewOnboardingSteps(true);
              setSurveyFormStep(8);
            }}
          />
        );
      case 8:
        return (
          <OnboardingModal
            show={showNewOnboardingSteps}
            onClose={onClose}
            showCross={false}
            steps={TRIAL_USER_ONBOARDING_MODAL_DATA}
            onComplete={() => setShowNewOnboardingSteps(false)}
            onVideoProgress={handleVideoProgress}
            customButtons={({ currentStep, totalSteps, handleNextStep, handlePreviousStep }) => (
              <NewOnboardingStepButtons
                currentStep={currentStep}
                totalSteps={totalSteps}
                handleNextStep={() => {
                  if (currentStep === totalSteps) {
                    setShowNewOnboardingSteps(false);
                    navigate('/dashboard/get-started');
                    onClose();
                  } else {
                    handleNextStep();
                  }
                }}
                handlePreviousStep={handlePreviousStep}
                isNextDisabled={isNextDisabled}
              />
            )}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <ModalComponent
      show={show}
      onClose={onClose}
      width={userType === 'v1' ? 930 : 552}
      bodyStyle={userType === 'v2' ? { padding: '0px 32px' } : {}}
      style={userType === 'v2' ? { padding: '32px 0px' } : {}}
      outsideClickClose={false}>
      <SurveyContext.Provider
        value={{
          surveyFormStep,
          setSurveyFormStep,
          form1Data,
          setForm1Data,
          form2Data,
          setForm2Data,
          form3Data,
          setForm3Data,
          form1V2Data,
          setForm1V2Data,
          form2V2Data,
          setForm2V2Data,
          userType,
          setUserType,
        }}>
        <div className="survey-modal-container">
          <SurveyProgress />
          {renderForm()}
        </div>
      </SurveyContext.Provider>
    </ModalComponent>
  );
}
